export default () => "\u00A0";
